module.exports = __webpack_public_path__ + "static/img/6729154.df02321c.jpg";